export default __webpack_public_path__ + "static/media/csv.23d0bd7d.svg";